module.exports = __webpack_public_path__ + "468ba968b9e506a7afa1fe45ce40f514.pdf";